export default "__VITE_ASSET__DEeMXmxD__"